import { getClientProductNumber } from 'utils/getProductNumber';
import {
  getDefaultCalculatorFromSession,
  SESSION_CALCULATOR_TYPE,
} from 'utils/constantsSession';
import { getFetchHeaders } from 'utils/fetchHeaders';
import { useEffect } from 'react';
import { useGetClient, useGetClientOffer, useGetOffer } from 'api';
import isAuthenticated from 'utils/isAuthenticated';

export const useOffer = () => {
  const isLogged = isAuthenticated();
  const { data: clientData } = useGetClient();
  const apiOffer = useGetOffer();
  const apiClientOffer = useGetClientOffer();

  const isLoggedAndAgeDefined = isLogged && clientData?.age;

  useEffect(() => {
    const apiToFetch = isLoggedAndAgeDefined ? apiClientOffer : apiOffer;
    const sessionCalculatorDataParsed: SESSION_CALCULATOR_TYPE | undefined =
      getDefaultCalculatorFromSession();
    if (
      !apiToFetch.isLoaded &&
      !apiToFetch.fetching &&
      sessionCalculatorDataParsed
    ) {
      apiToFetch.fetch({
        headers: getFetchHeaders(),
        pathParameters: {
          productNumber: getClientProductNumber(clientData?.availableProducts),
        },
        queryParameters: {
          amount: sessionCalculatorDataParsed.amount,
          term: sessionCalculatorDataParsed.term,
        },
      });
    }
  }, [
    isLoggedAndAgeDefined,
    apiClientOffer.isLoaded,
    apiClientOffer.fetching,
    apiOffer.isLoaded,
    apiOffer.fetching,
  ]);

  if (isLoggedAndAgeDefined) return apiClientOffer;
  return apiOffer;
};
